module.exports = __webpack_public_path__ + "img/10.061347ad.jpg";